class CollectionNavComponent extends HTMLElement {
  connectedCallback() {
    this.querySelector('[data-more-button]')?.addEventListener('click', this.#toggleDropdown);
    document.addEventListener('click', this.#handleOutsideClick, { capture: true });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.#handleOutsideClick, { capture: true });
  }

  #toggleDropdown = (event) => {
    event.stopPropagation();
    this.toggleAttribute('open');
  };

  #handleOutsideClick = (event) => {
    if (!this.contains(event.target)) {
      this.removeAttribute('open');
    }
  };
}

if (!customElements.get('collection-nav-component')) {
  customElements.define('collection-nav-component', CollectionNavComponent);
}
